module.exports = __webpack_public_path__ + "static/media/routeInfoMobileFull.5c192711.svg";